import { Table } from 'antd';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { t_medical_institution } from '../../types';
import { updateMedicalDetail } from '../MedicalInstitutionRegister/MedicalInstitutionDetail/slice';

type Props = {
  data: t_medical_institution[];
};

const TableMedical = ({ data }: Props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  return (
    <div>
      <Table
        rowKey="facility_id"
        onRow={(record) => {
          return {
            onClick: () => {
              dispatch(updateMedicalDetail(record));
              history.push('/medical_institution/detail');
            },
          };
        }}
        columns={columns}
        dataSource={data}
        pagination={false}
      />
    </div>
  );
};

const columns: any = [
  {
    title: '医療機関名',
    dataIndex: 'facility_name',
    key: 'facility_id',
    width: '17%',
    align: 'center',
    render(text: string) {
      return {
        props: {
          style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
          className: 'standardFont',
        },
        children: <div>{text}</div>,
      };
    },
  },
  {
    title: 'TEL',
    dataIndex: 'facility_tel',
    width: '14%',
    align: 'center',
    render(text: string) {
      return {
        props: {
          style: { textAlign: 'left' },
          className: 'standardFont',
        },
        children: <div>{text}</div>,
      };
    },
  },
  {
    title: '所在地',
    dataIndex: 'facility_address1',
    width: '23%',
    align: 'center',
    render(text: string) {
      return {
        props: {
          style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
          className: 'standardFont',
        },
        children: <div>{text}</div>,
      };
    },
  },
  {
    title: 'お取引先番号',
    dataIndex: 'facility_code',
    width: '10%',
    align: 'center',
    render(text: string) {
      return {
        props: {
          style: { textAlign: 'left' },
          className: 'standardFont',
        },
        children: <div>{text}</div>,
      };
    },
  },
  {
    title: '支払方法',
    dataIndex: 'payment_method',
    width: '8%',
    align: 'center',
    render(text: string) {
      return {
        props: {
          style: { background: 'rgba(246, 246, 246, 1)', textAlign: 'left' },
          className: 'standardFont',
        },
        children: <div>{text}</div>,
      };
    },
  },
  {
    title: 'CPAP単価',
    dataIndex: 'cpap_unit_price',
    width: '8%',
    align: 'center',
    render(text: string) {
      return {
        props: {
          style: { textAlign: 'left' },
          className: 'standardFont',
        },
        children: <div>{`￥ ${text ? parseInt(text).toLocaleString() : ''}`}</div>,
      };
    },
  },
];

export default TableMedical;
